import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { DEV_BYPASS_AUTH } from "@/lib/auth-config";

export function useDevBypassRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    if (DEV_BYPASS_AUTH) {
      navigate({ to: "/foyer", replace: true });
    }
  }, [navigate]);
}
